import type { Menu } from "@/types/models/menu"

import { mapMenu } from "../mappers/menu.mappers"

import {
  fetchSidebarMenuRepository,
  fetchSidebarItemsRepository,
  fetchPagesRepository,
  fetchSubPagesRepository,
  fetchMenuTenantsRepository,
  fetchMenuTenantsPagesRepository,
} from "../repositories/menu.respository"

export async function fetchMenuService(
  tenantId: number
): Promise<Menu | null> {
  try {
    const [
      menuData,
      sidebarItemsData,
      pagesData,
      subpagesData,
      tenantData,
    ] = await Promise.all([
      fetchSidebarMenuRepository(),
      fetchSidebarItemsRepository(),
      fetchPagesRepository(),
      fetchSubPagesRepository(),
      fetchMenuTenantsRepository(tenantId),
    ])

    if (!menuData?.length || !tenantData?.length) {
      return null
    }

    const menu = menuData[0]

    const tenantRelationsData =
      await fetchMenuTenantsPagesRepository(
        Number(tenantData[0].id)
      )

    return mapMenu({
      menu,
      sidebarItems: sidebarItemsData ?? [],
      pages: pagesData ?? [],
      subpages: subpagesData ?? [],
      tenantRelations: tenantRelationsData ?? [],
    })
  } catch (error) {
    console.error("Error building menu:", error)

    return null
  }
}